import fetch from "./sessionFetch";
import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

async function getClientNotificationHistory(clientId) {
  const query = `?recipientType=client&recipientId=${encodeURIComponent(clientId)}`;
  const response = await fetch(`${baseUrl}notifications${query}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function unsubscribeFromLessonReminders(token) {
  const query = `?token=${encodeURIComponent(token)}`;
  const response = await fetch(`${baseUrl}notifications/lesson-reminders/unsubscribe${query}`, {
    method: "GET",
  });

  if (response.ok) {
    await response.text();
    return { ok: true };
  }

  const error = await response.text();
  throw new Error(error || "Nie można wyłączyć przypomnień z tego linku.");
}

const paymentReminderUrl = `${baseUrl}notifications/payment-reminders`;

async function paymentReminderRequest(path, body) {
  const response = await fetch(`${paymentReminderUrl}/${path}`, {
    headers: authHeaders(body ? { "Content-Type": "application/json" } : {}),
    ...(body ? { method: "POST", body: JSON.stringify(body) } : {}),
  });
  return handleResponse(response);
}

function getPaymentReminderPreview(filters) {
  const query = Object.keys(filters).filter(key => filters[key] !== undefined && filters[key] !== "" && filters[key] !== null)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`).join("&");
  return paymentReminderRequest(`preview?${query}`);
}

export default {
  getPaymentReminderPreview,
  getPaymentReminderMessage: (clientId, obligationId) => paymentReminderRequest(`preview/${encodeURIComponent(clientId)}?obligationId=${encodeURIComponent(obligationId)}`),
  resendPaymentReminder: body => paymentReminderRequest("resends", body),
  getPaymentReminderRequest: requestId => paymentReminderRequest(`requests/${encodeURIComponent(requestId)}`),
  restorePaymentReminderConsent: (clientId, body) => paymentReminderRequest(`consents/${encodeURIComponent(clientId)}`, body),
  getClientNotificationHistory,
  unsubscribeFromLessonReminders,
};
